import React, { useState } from 'react';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiMenu, FiX } = FiIcons;

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-dark/95 backdrop-blur-md border-b border-dark-4 px-[8%] lg:px-[12%] h-[68px] flex items-center justify-between">
      <div className="font-condensed font-black text-[22px] leading-tight uppercase tracking-wide text-white">
        Eastern Shore<br/>Junk Removal
        <span className="text-white block text-[11px] tracking-[0.15em] font-semibold opacity-90">Salisbury & Eastern Shore, MD</span>
      </div>

      <ul className={`md:flex gap-8 list-none ${isOpen ? 'flex flex-col absolute top-[68px] left-0 right-0 bg-dark-2 p-5 border-b border-dark-4 z-40' : 'hidden'}`}>
        {['Services', 'How It Works', 'Areas', 'Reviews'].map((item) => (
          <li key={item}>
            <a 
              href={`#${item.toLowerCase().replace(/ /g, '-')}`} 
              onClick={() => setIsOpen(false)}
              className="text-text-muted no-underline text-sm font-medium tracking-wide transition-colors"
            >
              {item}
            </a>
          </li>
        ))}
      </ul>

      <a href="tel:4433592010" className="hidden md:flex bg-gold text-dark py-2.5 px-5 rounded font-condensed font-extrabold text-[15px] tracking-wider uppercase no-underline transition-all whitespace-nowrap">
        📞 443-359-2010
      </a>

      <button 
        className="md:hidden bg-transparent border-none cursor-pointer p-1 text-text"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle Menu"
      >
        <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-8 h-8" />
      </button>
    </nav>
  );
}